import { render, staticRenderFns } from "./SyncLogs.vue?vue&type=template&id=1bd828a6&"
import script from "./SyncLogs.vue?vue&type=script&lang=js&"
export * from "./SyncLogs.vue?vue&type=script&lang=js&"
import style0 from "./SyncLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports